var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.2 212.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5c020;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#a3581f;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#bb4e2e;}.cls-3{fill:#9b9f37;}.cls-4{fill:#4093a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.05.19c.94.8,1.26,4.66,1.53,5.78,3.14,13.21,5.2,28.21.14,41.21a37.89,37.89,0,0,1-21.59,21.45c-12.55,4.74-25,1.55-36.12-5.16a97.52,97.52,0,0,1-10.89-7.73c-2-1.62-4-3.31-5.85-5-1-.93-2-1.88-3-2.83-.62-.59-2.66-2-2.85-2.79a51.25,51.25,0,0,0,6.05,14.13A50.21,50.21,0,0,0,105,80.67c15.29,6,36,5.29,49.24-5.07a36.64,36.64,0,0,0,4-3.6c7-7.35,9.82-16.42,10.48-26.32a70.92,70.92,0,0,0-1.4-21.49S164.16,9.52,153.05.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.05,178c-8.2-19.22-13.77-42-6-62.34C131.91,82,170.71,74.2,189.63,105.28c9.82,16.14,13.19,36,15,54.47a28.91,28.91,0,0,0-1.39-5.18q-1.92-6.48-4.44-12.75c-4.74-11.74-11.16-24-21.53-31.74s-24.61-9-35.37-1c-7.64,5.65-11.49,14.79-13.9,23.71a113.33,113.33,0,0,0-3.5,26.19C124.44,160,124.31,178,125.05,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.05,79.3c1.94,1.84,5.14,3,7.34,4.62A59.22,59.22,0,0,1,62.2,97.47c10.41,14.7,7.18,37.35-6.4,49-12.16,10.42-28,10.26-42.08,3.95a56.77,56.77,0,0,1-12.67-7.55c11.58,3,24.91,4.4,36.64,1.67,7.92-1.84,13.94-6.23,17.55-13.68a41.11,41.11,0,0,0,1.24-31.3C53.44,91.59,47.12,85.05,41.05,79.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.38,211.3c-13-10.37-25.87-24.07-28.85-41.1-2.54-14.53,2.76-29.42,16.58-35.78a32.82,32.82,0,0,1,25.7-.61c15.62,6.19,26.62,21.3,34.9,35.21l.56.95c-8.05-9.66-19.35-18.8-31.5-22.42-16-4.77-33.9,4.6-34.51,22.14-.43,12.2,5.63,24.27,12,34.3A86,86,0,0,0,90.38,211.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.71,32.19c-.21,1.79.51,4.37,1,6.05a79.18,79.18,0,0,0,2.43,8.37,29.38,29.38,0,0,0,11.32,13.66c15,9.49,34.34,3,42.05-12.29a38.63,38.63,0,0,0,4.1-13.57c-.15,1.66.42,3.47.34,5.16-.12,2.65,0,5.35-.31,8a33.25,33.25,0,0,1-6.28,15.89c-5.88,7.9-14.58,12.09-24.19,13.16-12.79,1.41-23.11-4.8-27.57-17A61.48,61.48,0,0,1,207.71,32.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.55,123.13s8.24-26.79,27.2-30.2,22.22,21.78,22.52,45c0,0,13.78-43.55-9.11-53.77s-38.62,14.9-42.61,33.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 239.6,
    cy: 50.75,
    r: 10.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 125.78,
    cy: 43.18,
    r: 14.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.9,
    cy: 122.41,
    r: 12.51
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b7fb4f6689e5538d47f5057b7a35fc3.svg";
export { ForwardRef as ReactComponent };